import { useMemo } from "react";

import { useCollections } from "@/Apollo/hooks/useCollections";
import { PageProductBlock } from "@/common/contracts/page.contracts";
import { useLanguage } from "@/common/hooks/pages.hooks";
import { isCollection } from "@/common/utils/type-guards.utils";

export const HOMEPAGE_MARKETING_COLLECTION_PAGE_NAME = "homepage";

export const useHomepageMarketingCollection = () => {
  const { language } = useLanguage();

  const { data } = useCollections({
    variables: {
      name: HOMEPAGE_MARKETING_COLLECTION_PAGE_NAME,
      lang: language,
    },
  });

  const marketingCollection = useMemo<PageProductBlock | null>(() => {
    return data?.pageByKey?.blocks.find(isCollection) ?? null;
  }, [data?.pageByKey?.blocks]);

  return { marketingCollection };
};
